module.exports = __webpack_public_path__ + "img/mz.062f1bfa.png";